import { Box } from "@mui/joy";

import { useUser } from "../../../../hooks/query";
import { useEffect, useState } from "react";
import { DataGrid } from "../../../../components";

import { columnDef } from "./column-def";

export default function List() {
    const { useList } = useUser();
    const listUserSvc = useList();

    const [teams, setTeams] = useState([]);

    const fetchUserData = async () => {
        try {
            const response = await listUserSvc.mutateAsync({});
            setTeams(response);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <Box flex={1} height={300}>
            <DataGrid gridData={initialData} autoHeight={true} columnDefs={columnDef} />
        </Box>
    );
}

const initialData = [
    {
        id: 1,
        name: "Engineering",
        members: 0,
        description: "Handles all software development and infrastructure tasks.",
        createdAt: "2024-01-15T10:00:00Z",
    },
    {
        id: 2,
        name: "Design",
        members: 0,
        description: "Focuses on user experience, interface design, and brand identity.",
        createdAt: "2024-02-20T14:30:00Z",
    },
    {
        id: 3,
        name: "Marketing",
        members: 0,
        description: "Responsible for product promotion, outreach, and customer engagement.",
        createdAt: "2024-03-12T09:45:00Z",
    },
    {
        id: 4,
        name: "Product",
        members: 0,
        description: "Owns the product vision, roadmap, and feature prioritization.",
        createdAt: "2024-04-01T13:20:00Z",
    },
];
